export default {
  SPIN: 'DÖNDÜR',
  'You are not eligible for free spins':
    'Ücretsiz jetonlar için yalnızca CSGO ve VAC yasağı olmayan steam hesapları için uygundur. Güncellemek için siteye tekrar giriş yapın.',
  'It must be 24 hours since last roll': 'Son çekilişten sonra 24 saat geçmiş olmalı.',
};
